// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  functions:{
    getFirebaseUid:'https://us-central1-eventsweb-pm.cloudfunctions.net/getFirebaseUid'
  },

  /** Prod function */
  // functions:{
  //   getFirebaseUid:'https://us-central1-shoutout-c6349.cloudfunctions.net/getFirebaseUid'
  // },
  firebase: {
    /* EVENT-WEB */
    // apiKey: "AIzaSyB1sTEP5fkd_xZtRMp2o-lbvOt0df_T_8s",
    // authDomain: "eventsweb-pm.firebaseapp.com",
    // databaseURL: "https://eventsweb-pm.firebaseio.com",
    // projectId: "eventsweb-pm",
    // storageBucket: "eventsweb-pm.appspot.com",
    // messagingSenderId: "824646928487"

    /* PRODUCTION */
    apiKey: 'AIzaSyAtiRRlm3Q8qA2vtyymgiGw5S6HJWLout0',
    authDomain: 'shoutout-c6349.firebaseapp.com',
    databaseURL: 'https://shoutout-c6349.firebaseio.com',
    projectId: 'shoutout-c6349',
    storageBucket: 'shoutout-c6349.appspot.com',
    messagingSenderId: '841297967655',
  },
};



// WEBPACK FOOTER //
// /workspace/backend-server/src/environments/environment.ts